import React from 'react';

export const PiiIgnore: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="fs-exclude" data-testid="title">
    {children}
  </div>
);
